class WebAdjust {
  constructor() {}
}

export default new WebAdjust();
